export default __webpack_public_path__ + "static/media/visa-badge.ec56ed6a.jpg";